import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';


const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    zIndex: 1000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '800px',
    maxWidth: '90%',
    maxHeight: '90%'
  }
};

class TrackModal extends Component {
  state = {
    isOpen : false
  };
  constructor(props){
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ isOpen: nextProps.isOpen });
  }
  render() {
    return (
      <ReactModal
        style={modalStyles}
        isOpen={this.state.isOpen}
        contentLabel="Modal"
        onRequestClose={this.props.onCloseModal}
        shouldCloseOnOverlayClick={true}>
        {this.props.children}
      </ReactModal>
    );
  }
}

TrackModal.propTypes = {
  isOpen : PropTypes.bool.isRequired,
  onCloseModal : PropTypes.func
};

export default TrackModal;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Modals/TrackModal.js